export default __webpack_public_path__ + "static/media/play-dark.ee5e4e2c.svg";